module.exports = __webpack_public_path__ + "img/invite-hover.a4fb0fd0.svg";